import gsap from 'gsap';
import EventDispatcher from './EventDispatcher';
import Global from './Global';

const cookie1 = '/assets/UI/cookie1.png';
const cookie2 = '/assets/UI/cookie2.png';

// import { gsap } from "gsap";

export default class Result {
  constructor() {
    document
      .querySelector('#backToHomeResult_btn')
      .addEventListener('mousedown', this.backToHome.bind(this));
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    this.onProceed();
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data);
        break;
    }
  }

  showScreen(data) {
    if (data.screenKey != 'Result') return false;

    document
      .querySelector('#result_scr .resultBox #cookie')
      .classList.remove('cookie1');
    document
      .querySelector('#result_scr .resultBox #cookie')
      .classList.remove('cookie2');

    document.querySelector('#result_scr .resultBox #cookie').src =
      Global.votedKey == 'chocolate' ? cookie1 : cookie2;

    document
      .querySelector('#result_scr .resultBox #cookie')
      .classList.add(Global.votedKey == 'chocolate' ? 'cookie1' : 'cookie2');

    this.pageAnimation();
    document.querySelector('#result_scr').classList.add('active');
  }

  pageAnimation() {
    gsap.set('#backToHomeResult_btn', { opacity: 0 });
    gsap.fromTo(
      '#result_scr > .appContainer',
      { scale: 0.2, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power3.out' }
    );

    setTimeout(() => {
      setTimeout(() => {
        this.events.dispatchEvent({
          type: 'ANIMATION_EVENTS',
          message: {
            event_type: 'buttonAnimation',
            data: {
              selector: '#backToHomeResult_btn',
            },
          },
        });
      }, 1000);
    }, 500);
  }

  onProceed() {}

  backToHome() {
    Global.clickUpdater('backToHomeResult_btn');

    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'Home',
        },
      },
    });
  }
}
